import { useMutation } from '@tanstack/react-query';

import { Envelope } from '../../../../types';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { previewEnvelope } from '../../requests/previewEnvelope';

export const usePreviewEnvelope = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    Blob | undefined,
    Error,
    Envelope
  >({
    mutationFn: (envelope) => previewEnvelope(constructGet, envelope),
    onError: () => handleError('Failed to generate preview.'),
  });

  return { previewEnvelope: mutateAsync, ...rest };
};
